import { render, staticRenderFns } from "./ExpandableItem.vue?vue&type=template&id=7cd31afb&"
import script from "./ExpandableItem.vue?vue&type=script&lang=js&"
export * from "./ExpandableItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports